import { DocxPreviewViewer } from "./docx-preview-viewer"
import styles from "../styles/file-viewer.module.css"

export type DocxViewerProps = {
  fileUrl: string
  charactersPerPage?: number | undefined
  highlightQuote?: string | null
  highlightChunk?: string | null
  highlightSnippet?: string | null
  highlightScrollContainer?: HTMLElement | null
  onSlowRender?: () => void
}

// Renders read-only document for `.docx` files using docx-preview.
export function DocxViewer({
  fileUrl,
  charactersPerPage = undefined,
  highlightQuote = null,
  highlightChunk = null,
  highlightSnippet = null,
  highlightScrollContainer = null,
  onSlowRender,
}: DocxViewerProps) {
  const commonProps = {
    fileUrl,
    charactersPerPage,
    highlightQuote,
    highlightChunk,
    highlightSnippet,
    highlightScrollContainer,
    onSlowRender,
  }

  return (
    <div className={styles.infoContainer}>
      <DocxPreviewViewer {...commonProps} />
    </div>
  )
}
